export default __webpack_public_path__ + "locales/dnevnik.bua.json";